<template>
    <div>
        <v-select :items="$store.getters.getBoardsList"
                  label="View"
                  v-model="activeBoard"
        ></v-select>
        <div v-if="!editorMode">
            <v-layout row wrap>
                <v-flex xs8>
                    <div class="whiteboard-base">

                        <transition
                                enter-active-class="animated slideInLeft"
                                leave-active-class="">


                            <div id="whiteboard" :style="myStyle">

                                <template v-for="(item, index) in $store.state.whiteboardStore.notes"
                                          v-if="item.board==$store.state.whiteboardStore.activeBoard">
                                    <graphic-stickie v-bind="item"
                                                     :note="item"
                                                     :key="item.id"
                                                     v-if="item.type==='graphic'">
                                    </graphic-stickie>
                                </template>
                                <template v-for="(item, index) in $store.state.whiteboardStore.notes"
                                          v-if="item.board==$store.state.whiteboardStore.activeBoard">
                                    <sensor-value-label v-bind=item
                                                        :note="item"
                                                        :ind="item.id" :key="item.id"
                                                        v-if="!item.type"
                                    >
                                    </sensor-value-label>
                                </template>
                            </div>
                        </transition>
                    </div>
                </v-flex>
                <v-flex xs4>
                    <v-layout row wrap v-if="plotList.length>0">
                        <v-flex v-for="plot in plotList" :key="'ms'+plot.id"  v-bind:class="[plot['flex-class'], 'xs12']" >
                            <multi-plot-chart ref="plots" v-if="plot.type==='multi-chart'"
                                              disable-responsive
                                              just-plot
                                              :date-range="plot.config['range'] ? plot.config['range'] : dateRange"
                                              :variable-x="plot.config['variable-x']"
                                              :variables-list="plot.config['variables-list']"
                                              :layout-overrides="plot.config['layout-overrides']"
                                              :type="plot.config['type']"
                            ></multi-plot-chart>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>

        </div>

        <div v-if="editorMode">
            <editor v-model="editorData" @init="editorInit" lang="json" theme="chrome" width="100%" height="500"></editor>
            <v-btn @click="saveNoteChanges">
                <v-icon small class="mr-2">fa-save</v-icon>
                Apply changes
            </v-btn>
            <v-btn @click="editorMode=false">
                Cancel
            </v-btn>
        </div>
      <div>

            <v-toolbar dense flat class="secondary darken-1" v-if="$can('update', 'GraphicalView')">
            <v-tooltip top>
              <v-btn dark small icon flat slot="activator" @click="$store.dispatch('saveWhiteboard')">
                <v-icon small>fa-save</v-icon>
              </v-btn>
              <span>Save whiteboard</span>
            </v-tooltip>

                <v-tooltip top>
                    <v-btn dark small icon flat slot="activator" @click="switchToEditor">
                        <v-icon small>fa-edit</v-icon>
                    </v-btn>
                    <span>Edit all notes</span>
                </v-tooltip>

            <v-divider vertical class="grey"></v-divider>
            <v-tooltip top>
              <v-btn dark small icon flat slot="activator" @click="addStickie">
                <v-icon small>fa-plus</v-icon>
              </v-btn>
              <span>Add Stickie to board</span>
            </v-tooltip>



            <v-tooltip top>
              <v-btn dark small icon flat slot="activator" @click="addGraphic">
                <v-icon small>fa-image</v-icon>
              </v-btn>
              <span>Add Photo / Graphics to board</span>
            </v-tooltip>


            <v-divider class="grey" vertical></v-divider>

            <v-tooltip top>
              <v-btn dark small icon flat slot="activator" @click="addBoard">
                <v-icon small>fa-chalkboard</v-icon>
              </v-btn>
              <span>Add Board</span>
            </v-tooltip>
            <v-divider class="grey" vertical></v-divider>
            <v-spacer></v-spacer>
        </v-toolbar>
        <add-board-dialog ref="addBoardDialog"></add-board-dialog>
        </div>
    </div>
</template>

<script>
  import SensorValueLabel from './SensorValueLabel'
  import AddBoardDialog from './AddBoardDialog'
  import GraphicStickie from './GraphicStickie'
  import {getPoint} from '../../helper'
  import MultiPlotChart from "../MultiPlotChart"
  import editor from 'vue2-ace-editor'
  import moment from 'moment'


  export default {
    name: 'GraphicalSensorComponent',
    components: { GraphicStickie, AddBoardDialog, SensorValueLabel,editor,MultiPlotChart },
    data () {
      return {
          dateRange: {start: moment().subtract(1, "days").format('YYYY-MM-DD HH:mm:ss'), end: moment().format('YYYY-MM-DD HH:mm:ss')},
          editorMode:false,
          editorData:null,
        zoomRatio: 1.0,
          points:[],
          interval:null,
        activeBoard: this.$store.state.whiteboardStore.activeBoard
      }
    },
    watch: {
      activeBoard () {
        this.$store.commit('updateActiveBoard', this.activeBoard)
      },
      storeActiveBoard () {
        if (this.activeBoard != this.storeActiveBoard) {
          this.activeBoard = this.storeActiveBoard
        }
      }
    },
    computed: {
      fmtZoomRatio () {
        return (this.zoomRatio * 100).toFixed(0) + '%'
      },
      storeActiveBoard () {
        return this.$store.state.whiteboardStore.activeBoard
      },
        facility_name() {
            return this.$store.state.pointsListStore.facility_name
        },
        plotList(){
          let currentItems=this.$store.state.whiteboardStore.notes.filter(x=>x.board==this.$store.state.whiteboardStore.activeBoard&&x.sensor)
            if(currentItems.length==0){
                return []
            }
            let pvars={}
            for (let item of currentItems){
                let unit=this.getUnit(item.sensor.sensor_name,item.sensor.equipment_name)
                if(!pvars[unit]){
                    pvars[unit]=[]
                }
                pvars[unit].push({
                    equipment_name: item.sensor.equipment_name,
                    facility_name: item.sensor.facility_name,
                    name: item.sensor.sensor_name,
                })
            }
            let plots=[]
            for (let unit in pvars){
                plots.push({
                    'id': 'thing'+unit,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            xaxis: {
                                title: "Date "
                            },
                            yaxis: {
                                title: unit
                            },
                            showlegend: true,
                            legend: {
                                orientation:'h',
                                x: 0.1,
                                y: -0.5
                            }
                        },
                        'variables-list':pvars[unit],

                    }
                })
            }
            return plots

        }
    },
      beforeDestroy: function(){
          clearInterval(this.interval)
      },

    mounted () {
        let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
        if(maxDate){
            this.dateRange={
                start:moment(maxDate).subtract(1, "days").format('YYYY-MM-DD HH:mm:ss'),
                end: moment(maxDate).format('YYYY-MM-DD HH:mm:ss')
            }
        }
        let me=this;
        getPoint({
            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
        }).then(function(rez){
            me.points=rez.result
        })

        me.interval=setInterval(function() { me.$store.dispatch('refreshPoints') }, 300000);
      this.$store.dispatch('refreshWhiteboard')
      this.$store.dispatch('refreshPoints')
    },
    methods: {
        getUnit(varName,equipmentName){
            for (let point of this.points){
                if(point.sensor_name===varName&&point.equipment_name===equipmentName){
                    return point.unit
                }
            }
            return null;
        },
        switchToEditor(){
            this.editorData=JSON.stringify(this.$store.state.whiteboardStore.notes,null,4)
            this.editorMode=true
        },
        saveNoteChanges(){
            this.$store.commit("applyNotes",JSON.parse(this.editorData));
            this.editorMode=false
        },
        editorInit: function () {
            require('brace/ext/language_tools') //language extension prerequsite...
            require('brace/mode/json')

            require('brace/theme/chrome')
        },
      myStyle () {
          return {
            transform: 'scale(' + this.zoomRatio.toString() + ')',
            transformOrigin: '0% 0% 0px'
          }
      },
      zoom (num) {
          if (num) {
            this.zoomRatio *= num
          } else {
            this.zoomRatio = 1
          }
          if (this.zoomRatio > 2) this.zoomRatio = 2
          if (this.zoomRatio < 0.1) this.zoomRatio = 0.1
        return true
      },
      addBoard () {
        this.$refs.addBoardDialog.openDialog()
      },
      addStickie () {
        this.$store.dispatch('addToWhiteboard',
          {
            label: 'New Label',
            equipment: null,
            sensor: null,
            left: 10,
            top: 10,
            height: 100,
            width: 300,
            board: this.$store.state.whiteboardStore.activeBoard
          }
        )
      },
      addGraphic () {
        this.$store.dispatch('addToWhiteboard',
          {
            type: 'graphic',
            board: this.$store.state.whiteboardStore.activeBoard
          }
        )
      },
    }
  }
</script>

<style scoped>
#whiteboard {
    height: 1000px;
    width: 2000px;
    border: 1px solid darkgrey;
    position: relative;
  }

  .whiteboard-base {
    overflow: scroll;
    max-height: 85vh;
  }
</style>
